import { Component, OnInit } from '@angular/core';
import { Declarations } from 'src/app/data/declaration/models/declarations.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { DeclarationsService } from 'src/app/data/declaration/services/declarations/declarations.service';
import { DREVSaisie } from 'src/app/data/declaration/models/drevsaisie.model';
import { DeclarationRevendication } from 'src/app/data/declaration/models/declaration-revendication.model';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { SessionContext, NavigationContext } from 'src/app/core/services/config/app.settings';
import { RefCampagnesService } from 'src/app/data/declaration/services/ref-campagnes/ref-campagnes.service';
import { SaisieVciComponent } from '../affichage-drev/modals/saisie-vci/saisie-vci.component';

@Component({
    selector: 'app-consultation-drev',
    templateUrl: './consultation-drev.component.html',
    styleUrls: ['./consultation-drev.component.scss'],
    standalone: false
})
export class ConsultationDrevComponent implements OnInit {
    public declarations: Declarations;
    public annee: number;
    public formGroup: UntypedFormGroup;
    get commission() {
        return this.formGroup.get('commission');
    }

    constructor(
        private readonly declarationsService: DeclarationsService,
        private readonly refCampagnesService: RefCampagnesService,
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly modalService: NgbModal,
        private readonly fb: UntypedFormBuilder
    ) {}

    ngOnInit() {
        this.formGroup = this.fb.group({
            commission: [undefined, [Validators.required, Validators.pattern(/(19|20)\d\d/)]]
        });

        if (NavigationContext.get('idOperateur') === undefined) {
            this.router.navigate(['/main/operateurs/or/recherche-affilie']);
        } else {
            this.refCampagnesService.getCampagneEnCours().subscribe(campagne => {
                this.annee = campagne.annee;

                this.route.params.subscribe(vals => {
                    const commission = vals.annee;
                    if (commission) {
                        this.commission.setValue(commission);
                    } else {
                        this.commission.setValue(this.annee);
                    }
                    this.loadData(commission);
                });

                this.commission.valueChanges.subscribe(commission => {
                    if (this.commission.valid) {
                        this.router.navigate([commission], { relativeTo: this.route.parent });
                    }
                });
            });
        }
    }

    get idIntervenant(): number {
        if (NavigationContext.has('idOperateur')) {
            return NavigationContext.get('idOperateur');
        } else {
            return SessionContext.get('idIntervenant');
        }
    }

    private loadData(annee: string) {
        // Récupérer les declarations AOC
        this.declarationsService.getConsultationDREV(this.idIntervenant, annee === undefined ? this.annee.toString() : annee).subscribe(
            declarations => (this.declarations = declarations),
            error => {
                try {
                    if (error.error.code === 'BACCHUS_BUSINESS_NO_DR') {
                        this.declarations.aocs = [];
                        this.declarations.igps = [];
                        return;
                    }
                } catch (e) {
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                }
                throw error;
            }
        );
    }

    utilisationVci(declaration: DeclarationRevendication) {
        const modal = this.modalService.open(SaisieVciComponent, { backdrop: 'static', size: 'xl' as any });
        (modal.componentInstance as SaisieVciComponent).campagne = this.commission?.value;;
        (modal.componentInstance as SaisieVciComponent).drev = declaration;
        (modal.componentInstance as SaisieVciComponent).saisie = declaration.drevSaisie;
        (modal.componentInstance as SaisieVciComponent).creation = false;

        modal.result.then((saisie: DREVSaisie) => {
            declaration.setSaisieVci(saisie);
        });
    }
}
